import { iterationPerDomain } from "./genericRequest";

const domains = [
  'https://wallets-neon.ponzilover.com',
  'https://users.ponzilover.com',
];

export const searchRequest = async (firstName, lastName) => {

  const path = `/api/names?first_name=${firstName}&last_name=${lastName}`
  return await iterationPerDomain(domains, path);

};
